import FooterLinks from "./FooterLinks";
import { FaWhatsapp, FaLinkedin, FaXTwitter } from "react-icons/fa6";
import FooterLogo from "./FooterLogo";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="xsm:pb-10 bg-white text-[#27335d] sm:pb-14 md:pb-0">
      <div className="mx-auto w-full max-w-(--breakpoint-xl) p-4 py-8 lg:py-12">
        <div className="flex flex-row items-center justify-between">
          <div className="mb-0 flex flex-row items-center space-y-0">
            <FooterLogo />
            <div className="xsm:mx-4 xsm:h-20 xsm:w-[5px] mx-6 h-16 w-[4px] bg-[#27335d] sm:mx-6 sm:h-24 sm:w-[6px] md:mx-8 md:h-28 md:w-[7px] lg:mx-10 lg:h-32 lg:w-[8px] xl:mx-12 xl:h-36 xl:w-[9px]"></div>
            <FooterLinks />
          </div>
        </div>
        <hr className="my-4 border-gray-200 sm:mx-auto lg:my-6 dark:border-gray-700" />
        <address className="mb-4 text-center not-italic leading-relaxed text-[#6B7280] md:text-left" style={{ fontSize: "13px" }}>
          Rawiah Arabic Language Institute<br />
          Al Raed District, King Abdullah Ibn Abdulaziz Rd.<br />
          Riyadh 12354, Saudi Arabia
        </address>
        <div className="flex flex-col text-center sm:items-center sm:justify-between md:flex-row">
          <div className="mb-4 flex justify-center">
            <p className="xsm:text-xs font-serif font-semibold text-[#27335d] sm:text-center sm:text-sm">
              © {currentYear} Rawiah. All rights reserved.
            </p>
          </div>
          <div className="flex justify-center">
            <div className="flex flex-wrap justify-center gap-2">
              <div className="flex flex-col items-center justify-center rounded-full bg-[#27335D] p-2 text-center text-base text-white">
                <a href="https://wa.me/966557319070" target="_blank" data-testid="footerWhatsappLink">
                  <FaWhatsapp />
                </a>
              </div>
              <div className="flex flex-col items-center justify-center rounded-full bg-[#27335D] p-2 text-center text-base text-white">
                <a
                  href="https://www.linkedin.com/company/rawiah"
                  target="_blank"
                  data-testid="footerLinkedinLink"
                >
                  <FaLinkedin />
                </a>
              </div>
              <div className="flex flex-col items-center justify-center rounded-full bg-[#27335D] p-2 text-center text-base text-white">
                <a href="https://x.com/rawiah_ar" target="_blank" data-testid="footerTwitterLink">
                  <FaXTwitter />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
